import { render, staticRenderFns } from "./SairamCard.vue?vue&type=template&id=d2ccedae"
import script from "./SairamCard.vue?vue&type=script&lang=ts"
export * from "./SairamCard.vue?vue&type=script&lang=ts"
import style0 from "./SairamCard.vue?vue&type=style&index=0&id=d2ccedae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports